import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form, Tabs, Tab } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonSuggestSelect from '../components/CommonSuggestSelect';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

import InlineSupplyDataSupplyHrInOut from '../inline/InlineSupplyDataSupplyHrInOut';
import InlineSupplyDataSupplyHrIndustries from '../inline/InlineSupplyDataSupplyHrIndustries';
import InlineSupplyDataSupplyHrSkillsSet from '../inline/InlineSupplyDataSupplyHrSkillsSet';

class InputSupplyDataSupplyHr extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            activeTab: 'profile'
        };
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); }

    handleTabSelect = (key) => { this.setState({ activeTab: key }); };       

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }

    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onSetEdit } = props;

        let { App, Action, Inputs, InputGroup , Operation, Masterbase, UserCookie } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': '100vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => { 
                        this.setState({activeTab: 'profile'});
                        props.onClose(e);
                    }}
                >

                  <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                     <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            <Container fluid className="data-table-container">

                                <Tabs 
                                    defaultActiveKey="profile" 
                                    activeKey={this.state.activeTab}
                                    onSelect={(e) => this.handleTabSelect(e)}
                                    className="mb-3"
                                >
                                
                                    <Tab eventKey="profile" title="ผลผลิตกำลังคน">
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.academy_id)}</Col>
                                            <Col md={5} className="mb-3">
                                                <CommonSuggestSelect
                                                    element="Inputs"
                                                    input={Inputs.academy_id}
                                                    option={{source: 'db', data: Masterbase?.academy}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                    disabled={!['0','1'].includes(UserCookie?.types)}
                                                />
                                            </Col>
                                        </Row>  
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.faculty_id)}</Col>
                                            <Col md={5} className="mb-3">
                                                <CommonSuggestSelect
                                                    element="Inputs"
                                                    input={Inputs.faculty_id}
                                                    option={{source: 'db', data: Masterbase?.faculty}}

                                                    hr={false}
                                                    floatingLabel={false}

                                                    callback={(e, element) => {
                                                        onInputChange(e, element);
                                                        onInputChange({ target: { name: 'department_id', value: '' } }, element);
                                                        onInputChange({ target: { name: 'department_work_id', value: '' } }, element);
                                                    }}
                                                />
                                            </Col>
                                        </Row>   
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.department_id)}</Col>
                                            <Col md={5} className="mb-3">
                                                <CommonSuggestSelect
                                                    element="Inputs"
                                                    input={Inputs.department_id}
                                                    option={{
                                                        source: 'db', 
                                                        data: 
                                                            Inputs.faculty_id.value !== '' ? 
                                                            Masterbase?.department.filter( (d) => d.faculty_id === Inputs.faculty_id.value )
                                                        : []
                                                    }}

                                                    hr={false}
                                                    floatingLabel={false}

                                                    callback={(e, element) => {
                                                        onInputChange(e, element);
                                                        onInputChange({ target: { name: 'department_work_id', value: '' } }, element);
                                                    }}
                                                />
                                            </Col>
                                        </Row>  
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.department_work_id)}</Col>
                                            <Col md={5} className="mb-3">
                                                <CommonSuggestSelect
                                                    element="Inputs"
                                                    input={Inputs.department_work_id}
                                                    option={{
                                                        source: 'db', 
                                                        data: 
                                                            Inputs.department_id.value !== '' ? 
                                                            Masterbase?.department_work.filter(
                                                                (d) => d.department_id === Inputs.department_id.value
                                                            )
                                                            : []
                                                    }}

                                                    hr={false}
                                                    floatingLabel={false}

                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                        </Row>
                                    </Tab>                                

                                    <Tab eventKey="student" title="นักศึกษา">
                                        <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineSupplyDataSupplyHrInOut
                                                    fkId="supply_hr_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>                                        
                                        </Row>                                         
                                    </Tab>

                                    <Tab eventKey="skills-set" title="ทักษะ Skills Set">
                                        <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineSupplyDataSupplyHrSkillsSet
                                                    fkId="supply_hr_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>                                        
                                        </Row>                                         
                                    </Tab>

                                    <Tab eventKey="industries" title="อุตสาหกรรม">
                                        <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineSupplyDataSupplyHrIndustries
                                                    fkId="supply_hr_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>                                        
                                        </Row>                                         
                                    </Tab>                                    

                                </Tabs>    

                            </Container>                          
                            
                        </SimpleBar>

                    </Offcanvas.Body>  


                   { this.state.activeTab === 'profile' && (
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">

                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => {
                                        let currentId = Inputs.id.value;
                                        await onSubmit(e);
                                        if (Action.Mode === 'update') {
                                            onSetEdit({}, {id: currentId}); 
                                        }
                                        this.handleTabSelect('profile');
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>       
                   ) }

                </Offcanvas>
            )
        }
}

export default InputSupplyDataSupplyHr;    